import { Issue } from '../types';
import { csvEscape, csvEscapeRaw } from './csvSafe';
import { DateFormat } from './DateFormat';

const HEADERS = [
  'Автор',
  'Описание',
  'Дата',
  'Важность',
  'Статус',
  'Полёт',
  'Дата устранения',
  'Кем устранена',
  'Стоимость руб',
  'Комментарий',
] as const;

const severityLabel = (severity: string) =>
  severity === 'low' ? 'Низкая' : severity === 'high' ? 'Высокая' : 'Средняя';

/**
 * Дата как текстовая формула Excel: ="ДД.ММ.ГГГГ".
 * Иначе Excel делает из неё «дату-число» и при узкой колонке рисует ######.
 */
function asDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '';
  const d = DateFormat(String(dateStr), 'dot');
  return `="${d}"`;
}

function asDecimal(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return String(n).replace('.', ',');
}

function asText(value: string | null | undefined): string {
  if (value == null) return '';
  return String(value);
}

function rowValues(issue: Issue): string[] {
  return [
    csvEscape(asText(issue.author)),
    csvEscape(asText(issue.description)),
    csvEscapeRaw(asDate(issue.issue_date || issue.created_at)),
    csvEscape(severityLabel(issue.severity || 'medium')),
    csvEscape(issue.is_resolved ? 'Устранена' : 'Открыта'),
    csvEscapeRaw(asDate(issue.flight_date)),
    csvEscapeRaw(asDate(issue.resolved_at)),
    csvEscape(asText(issue.resolved_by)),
    csvEscapeRaw(asDecimal(issue.cost)),
    csvEscape(asText(issue.comment)),
  ];
}

/** CSV с `;` и BOM — нормально открывается в Excel (RU). */
export function buildIssuesCsv(issues: Issue[]): string {
  const lines = [
    HEADERS.join(';'),
    ...issues.map((issue) => rowValues(issue).join(';')),
  ];
  return `\uFEFF${lines.join('\r\n')}\r\n`;
}

export function downloadIssuesCsv(
  issues: Issue[],
  filenameBase = 'issues'
): void {
  const csv = buildIssuesCsv(issues);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filenameBase}-${stamp}.csv`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
